import * as React from 'react';
import cx from 'classnames';
type Props = React.SVGProps<SVGSVGElement> & {
  size?: number;
};
export function Svg0294PhoneCallRinging(ps: Props) {
  const style = Object.assign(
    {},
    ps.style,
    ps.size
      ? {
          width: ps.size,
          height: ps.size,
        }
      : {},
  );
  const props: Props = Object.assign({}, ps, {
    style,
    className: cx('svg-icon', ps.className),
  });
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M16.5 13.9c-.2-.2-.5-.2-.7 0 0 0-1.4 1.3-1.5 1.4l-.1.1c-1.4.7-6.6-4.8-5.6-5.8l1.5-1.4c.2-.2.2-.5 0-.7L5.4 2.6c-.1-.1-.2-.2-.3-.2-.1 0-.2 0-.3.1-2.4 2.4-6.3 4.8 2.7 13.9 8.9 9 11.4 5.6 13.8 3 .2-.2.2-.5 0-.7l-4.8-4.8zm4.2-3.6c.1-3.9-3.1-7.1-7-7m10.4 7C24.2 4.5 19.5-.2 13.7 0m0 6.7c2.1-.1 3.7 1.6 3.6 3.6" />
    </svg>
  );
}
